module.exports = __webpack_public_path__ + "media/images/riders/small/CARLOS_COLOMA_NICOLAS-f74550b635f8144fe9561df7268223b3.png";